export const sumNumberSafe = (a: number, b: number, multiplier = 1e8) => {
	return (Math.round(a * multiplier) + Math.round(b * multiplier)) / multiplier;
};
